function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dataList from "./assets/shoppingData.json";
import { ShoppingItem } from "imagica-corekit/dist/base/api/shoppingTyped/Shopping";
import { GenUtil } from "imagica-corekit/dist/base/cutil/GenUtil";
import { JsonUtil } from "imagica-corekit/dist/base/cutil/JsonUtil";
import { signal } from "@preact/signals-react";
import { DISPLAY_COUNT } from "../Constant";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { VBDataShoppingProductItem, VBDataShoppingProductSource } from "imagica-corekit/dist/base/api/viewBuilderTyped/VBGraphData/VBDataShoppingProduct";
export var ShoppingSearchResultsBlocState = /*#__PURE__*/function () {
  function ShoppingSearchResultsBlocState() {
    _classCallCheck(this, ShoppingSearchResultsBlocState);
    _defineProperty(this, "currentPage", 0);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "list", []);
    _defineProperty(this, "showLoadMore", true);
    _defineProperty(this, "detailProductItem", void 0);
  }
  _createClass(ShoppingSearchResultsBlocState, [{
    key: "copyWith",
    value: function copyWith(params) {
      return GenUtil.copyWith(new ShoppingSearchResultsBlocState(), this, params);
    }
  }]);
  return ShoppingSearchResultsBlocState;
}();
export var ShoppingSearchResultsBloc = /*#__PURE__*/function () {
  function ShoppingSearchResultsBloc(props) {
    _classCallCheck(this, ShoppingSearchResultsBloc);
    _defineProperty(this, "state", signal(new ShoppingSearchResultsBlocState()));
    this.props = props;
    this.state.value = this.state.value.copyWith({
      currentPage: 1,
      list: props.product_list
    });
  }
  _createClass(ShoppingSearchResultsBloc, [{
    key: "setShowDetail",
    value: function setShowDetail(detailItem) {
      var newState = this.state.value.copyWith({
        detailProductItem: detailItem
      });
      newState.detailProductItem = detailItem;
      this.state.value = newState;
    }
  }, {
    key: "shoppingItemsToProductItems",
    value: function shoppingItemsToProductItems(sItems) {
      return sItems.map(function (item) {
        var productItem = new VBDataShoppingProductItem();
        productItem.product_image = item.image;
        productItem.product_name = item.title;
        productItem.product_rating = "".concat(item.rating);
        productItem.product_reviews = "".concat(item.reviews);
        productItem.product_price = "$".concat(item.price);
        productItem.buy_button = "Buy for $".concat(item.price);
        var source = new VBDataShoppingProductSource();
        source.source_text = "amazon";
        source.source_icon = "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "vb-test/amazon.png");
        productItem.source = source;
        return productItem;
      });
    }
  }, {
    key: "loadMore",
    value: function loadMore() {
      var _JsonUtil$toArrayFrom;
      var data = (_JsonUtil$toArrayFrom = JsonUtil.toArrayFromType(ShoppingItem, dataList.data.sofa.items)) !== null && _JsonUtil$toArrayFrom !== void 0 ? _JsonUtil$toArrayFrom : [];
      var newData = this.shoppingItemsToProductItems(data);
      var oldData = this.state.value.list;
      var allData = this.props.product_list.concat(newData);
      var len = oldData.length + DISPLAY_COUNT;
      this.state.value = this.state.value.copyWith({
        currentPage: 1,
        list: allData.slice(0, len),
        showLoadMore: len <= allData.length
      });
    }
  }]);
  return ShoppingSearchResultsBloc;
}();